<template>
    <card-seplag titulo="Certidões">
            <Rotulo cols="12 4" nome="Selecionar certidões:">
                <Dropdown v-model="tipoCertidaoSelecionada" :options="listaTipoCertidao" optionLabel="name" optionValue="code" placeholder="Selecione a certidão desejada" />
            </Rotulo>

            <Rotulo cols="12 2" >
                <Button label="Gerar certidão"  style="margin-top:15px" @click="gerarCertidao()"/>
            </Rotulo>
            <div v-if="exibeMsg" class="p-grid p-col-12 avisos" style="align:center;margin-top:15px;margin-left:5px">
                <ul style="margin-left:7px">
                    <li style="font-size:15px;margin-bottom: 15px">Prezado usuário(a) por gentileza procurar:</li>
                    <li style="font-size:15px;margin-bottom: 5px;margin-left:10px">I- Servidor civil, à Unidade Setorial de Correição, à Comissão Permanente ou Processante do órgão ou entidade de lotação, à Corregedoria Geral da Polícia Judiciária Civil.</li>
                    <li style="font-size:15px;margin-left:10px">II- Servidor militar, à Seção de Justiça e Disciplina (SJD), à Divisão de Justiça e Disciplina (DJD) ou à Corregedoria Geral da Polícia Militar ou à Corregedoria Geral do Corpo de Bombeiros Militar.</li>
                    <li style="font-size:15px;margin-left:10px">III- Demais interessados, à Controladoria Geral do Estado.</li>
                    <!-- III- Demais interessados, à Controladoria Geral do Estado. -->
                </ul>
            </div>    
             <CardExibirPDF v-if="pdfElement" v-model="exibirPDF" :nomeDocumento='nomeDocumentoPDF' :tituloTela="this.titulo" :position="'top'" :tamanhoTela="'55.em'"  :alturaTela="'55.em'" :pdfElement="pdfElement" />  
    </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import {baseApiUrlCertidao} from '@/config/global'
import Rotulo from '@/template/RotuloSeplag.vue'
import CardExibirPDF from '@/template/CardExibirPDF.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'vinculo',
    components: { CardSeplag, Rotulo, CardExibirPDF},
    data: function() {
        return{
           tipoCertidaoSelecionada:null,
           exibirPDF: false,
           pdfElement: null,
           nomeDocumentoPDF: 'Vinculo Servidor',
           exibeMsg:false,
           titulo:'',
           listaTipoCertidao: [
                {name:'Certidão Negativa Correcional', code: 'negativaDisciplinar'},
                {name:'Certidão de Vínculo Funcional', code: 'vinculoFuncional'},
                {name:'Certidão de Vínculo Previdenciário', code: 'vinculoPrevidenciario'}
            ]
        }
    },
     mounted(){
        
        if((process.env.VUE_APP_AMBIENTE == "PRODUCAO")){
            this.listaTipoCertidao = this.listaTipoCertidao.filter((({code}) => code != "negativaDisciplinar" ))
        }
    },
    methods: {  
        gerarCertidao(){
           // let matricula =  this.$store.getters.getMatricula
            let JsonVinculoFuncional ={
                        "matricula" :  this.$store.getters.getMatricula,
                        "nome": this.getUser.contaAcesso.pessoa.nomePessoa,
                        "cpf": this.getUser.contaAcesso.pessoa.numrCpf,
                        "rg": this.getUser.contaAcesso.pessoa.numrRg,
                        "orgaoRg": this.getUser.contaAcesso.pessoa.clasOrgaoEmissorRg + "/"+this.getUser.contaAcesso.pessoa.ufRg.siglUf,
                        //"orgaoRg": "AAA",
                        "tipoCertidaoEnum": "COMPLETA",
                        "saida":"I"
            }

            let JsonNegativaDiscip ={
                        "nome": this.getUser.contaAcesso.pessoa.nomePessoa,
                        "cpf": this.getUser.contaAcesso.pessoa.numrCpf,
                        "rg": this.getUser.contaAcesso.pessoa.numrRg,
                        "orgaoRg": this.getUser.contaAcesso.pessoa.clasOrgaoEmissorRg + "/"+this.getUser.contaAcesso.pessoa.ufRg.siglUf,
            }

            let JsonVinculoPrevidenciario ={

                        "nome": this.getUser.contaAcesso.pessoa.nomePessoa,
                        "cpf": this.getUser.contaAcesso.pessoa.numrCpf,
                        "tipoCertidaoEnum": "COMPLETA"
            }
            switch (this.tipoCertidaoSelecionada) {
                case "negativaDisciplinar":
                    this.exibeMsg = false
                     this.$http.post(`${baseApiUrlCertidao}/certidaodisciplinar/gerar`,JSON.stringify(JsonNegativaDiscip)).then(res => {
                       //console.log()
                        if (res.data.nomeArquivo == null){
                            this.exibeMsg = true
                        }else{
                            this.pdfElement = res.data.dadosRelatorioBase64
                            this.nomeDocumentoPDF = res.data.nomeArquivo
                            this.exibirPDF = true
                        }    
                        this.titulo = 'Certidão Negativa Correcional'
                    })
                    break;

                case "vinculoFuncional":
                    this.exibeMsg = false
                    this.$http.post(`${baseApiUrlCertidao}/certidaovinculo/gerar`,JSON.stringify(JsonVinculoFuncional)).then(res => {
                        this.pdfElement = res.data.dadosRelatorioBase64
                        this.nomeDocumentoPDF = res.data.nomeArquivo
                        this.exibirPDF = true
                        this.titulo = 'Certidão de Vínculo Funcional'
                    })
                    break;

                case "vinculoPrevidenciario":
                    this.exibeMsg = false
                    this.$http.post(`${baseApiUrlCertidao}/certidaoprevidenciaria/gerar`,JSON.stringify(JsonVinculoPrevidenciario)).then(res => {
                    this.pdfElement = res.data.dadosRelatorioBase64
                    this.nomeDocumentoPDF = res.data.nomeArquivo
                    this.exibirPDF = true
                    this.titulo = 'Certidão de Vínculo Previdenciário'
            })
                    break;
            }        
        }     
    },
    computed:{
      ...mapGetters(['getVinculo','getUser'])
    }, 

}
</script>

<style>
.avisos{
    background-color: rgb(231 232 125 / 84%);/*rgb(250 86 86 /65%) rgb(231 232 125 / 84%);*/
    color: #000000;
    border-radius: 12px;
    padding-left: 15px;
}
</style>